
import React, { useState } from 'react';

const Sudoku: React.FC = () => {
  // Static partial grid for simplicity
  const [grid, setGrid] = useState([
    [5,3,0,0,7,0,0,0,0], [6,0,0,1,9,5,0,0,0], [0,9,8,0,0,0,0,6,0],
    [8,0,0,0,6,0,0,0,3], [4,0,0,8,0,3,0,0,1], [7,0,0,0,2,0,0,0,6],
    [0,6,0,0,0,0,2,8,0], [0,0,0,4,1,9,0,0,5], [0,0,0,0,8,0,0,7,9]
  ]);

  const handleChange = (r: number, c: number, v: string) => {
    const val = parseInt(v) || 0;
    if (val < 0 || val > 9) return;
    const newGrid = [...grid.map(row => [...row])];
    newGrid[r][c] = val;
    setGrid(newGrid);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="grid grid-cols-9 gap-1 bg-slate-800 p-2 rounded-xl border-4 border-slate-900">
        {grid.map((row, r) => row.map((cell, c) => (
          <input
            key={`${r}-${c}`}
            type="text"
            maxLength={1}
            value={cell === 0 ? '' : cell}
            onChange={(e) => handleChange(r, c, e.target.value)}
            className={`w-8 h-8 md:w-10 md:h-10 text-center font-bold rounded-sm ${
              (Math.floor(r/3) + Math.floor(c/3)) % 2 === 0 ? 'bg-slate-700' : 'bg-slate-600'
            } text-white focus:bg-blue-600 outline-none transition-colors`}
          />
        )))}
      </div>
      <p className="mt-8 text-slate-500 font-mono text-[10px] uppercase">Verify the integrity of the data cluster.</p>
    </div>
  );
};

export default Sudoku;
